<template>
    <section class="small-right">
        <div class="gray hold spacing">

            <h2>The indispensable elements of voice</h2>
            <h3>Voice services must be instantly available and easy to use.</h3>

            <p>Voice is the most natural way to communicate with machines.</p>


            <div class="card-holder">

                <div class="flip-card">
                    <div class="flip-card-inner">
                        <div class="flip-card-front">
                            <div class="icon-holder">
                                <lottie :name="'introduction/01-icon-animations-1-blue'" :width="300" :height="304" />
                            </div>
                            <div>The green button experience with global reach. Emergency calls and critical voice services.</div>
                        </div>
                        <div class="flip-card-back">
                            <div class="icon-holder">
                                <lottie :name="'introduction/01-icon-animations-1-white'" :width="300" :height="304" />
                            </div>
                            <div>
                                Consumers expect to be able to speak across the globe, instantly, securely and at any time when they press the green button. <br><br>
                                Being able to call for emergency help is central to people’s sense of safety and the security of society. Mission-critical voice services meet the regulatory needs of public safety users.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flip-card">
                    <div class="flip-card-inner">
                        <div class="flip-card-front">
                            <div class="icon-holder">
                                <lottie :name="'introduction/01-icon-animations-2-blue'" :width="300" :height="304" />
                            </div>
                            <div>Voice is embedded into non-telephony applications or IoT.</div>
                        </div>
                        <div class="flip-card-back">
                            <div class="icon-holder">
                                <lottie :name="'introduction/01-icon-animations-2-white'" :width="300" :height="304" />
                            </div>
                            <div>
                                Communicate, measure, manage, and control IoT and applications in the cloud with voice interactions. Use voice-activated commands and get voice responses. Integrate 5G programmable voice to cloud-based services.
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    .card-holder {
        position: absolute;
        bottom: 120px;
        left: 40px;
        right: 0;
        display: flex;

        @include custom-breakpoint(1000) {
            flex-direction: column;
        }
    }

    .flip-card {
        background-color: transparent;
        width: 500px;
        height: 270px;
        perspective: 1000px;
        cursor: pointer;

        &:not(:last-child) { margin-right: 50px; }
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        transition: transform 0.8s;
        transform-style: preserve-3d;
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateX(180deg);
    }

    .flip-card-front, .flip-card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden; /* Safari */
        backface-visibility: hidden;
        padding: 30px;
        display: flex;
        align-items: center;

        .icon-holder {
            display: flex;
            align-items: center;
            height: 120px;
            flex: 0 0 100px;
            margin-right: 30px;
        }
    }

    .flip-card-front {
        background-color: white;
        color: black;
    }

    .flip-card-back {
        background-color: $color-blue;
        color: white;
        transform: rotateX(180deg);
    }

</style>